module.exports = __webpack_public_path__ + "static/media/sad.6b8fef7d.png";